module.exports = __webpack_public_path__ + "static/logo-ba11ec80081c18577f548f65fba89759.png";